var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('router-view'),_c('FooterNav',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginInfo),expression:"loginInfo"}]}),_c('LoginPanel',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name == 'position'),expression:"$route.name == 'position'"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }